import axios from './servicecallsInterceptor';
import { store } from '..';

export function Get(url, cancellationSource) {
    const token = store.getState().app.token;
    const headers = {
        "Content-Type": "application/json; charset=UTF-8; odata=verbose",
        "Access-Control-Allow-Origin": "*",
        //"version": "v1",
        "Cache-Control": "No-Store",
        "Access-Control-Max-Age": 600,
        "Authorization": `Bearer ${token}`
    };

   return axios({
        method: 'get',
        url: url,
        headers: headers,
        cancelToken: (cancellationSource && cancellationSource.token ) ? cancellationSource.token : null
    }); 
}

export function Post(url, requestBody, cancellationSource) {
    const token = store.getState().app.token;
    const headers = {
        "Content-Type": "application/json; charset=UTF-8; odata=verbose",
        "Access-Control-Allow-Origin": "*",
        //"version": "v1",
        "Cache-Control": "No-Store",
        "Access-Control-Max-Age": 600,
        "Authorization": `Bearer ${token}`
    };

    return axios({
        method: 'post',
        url: url,
        data: requestBody,
        headers: headers,
        cancelToken: (cancellationSource && cancellationSource.token ) ? cancellationSource.token : null
    })
    
}

export function PostMultiPart(url, requestBody, cancellationSource, onUploadProgress){
    const token = store.getState().app.token;
    const headers = {
        //Note:  Ask apim to have allowed header * to upload multipart files
        "Access-Control-Allow-Origin": "*",
        "Authorization": `Bearer ${token}`
    }

    return axios({
        method: 'post',
        url: url,
        data: requestBody,
        headers: headers,
        onUploadProgress: onUploadProgress? (progressEvent) => { onUploadProgress(progressEvent) }:null,
        cancelToken: (cancellationSource && cancellationSource.token ) ? cancellationSource.token : null
    })
}